<template>
    <div>
        <h1 class="display-heading">My Profile</h1>

        <div class="mb-3">
            <user-profile-common ref="userProfileForm" v-model="userProfile"></user-profile-common>
        </div>

        <div class="form-row">
            <div class="form-group">
                <div class="mb-2 small text-danger">
                    * Required fields.
                </div>
            </div>
        </div>

        <p v-show="isSubmitMessageShown" :class="{
            'text-danger': isSubmitMessageError
        }">
            {{submitMessage}}
        </p>

        <button type="button" class="btn btn-primary btn-primary-insv mr-2" @click="saveProfile">
            Save Changes
        </button>
        <button type="button" class="btn btn-secondary" @click="getProfile">Cancel Changes</button>

        <popup-modal ref="popupCompleteProfile" :hasCloseButton="false" title="Complete your Profile">
            <template slot="content">
                <p>Please complete your profile before proceeding with other actions.</p>
                <p>Thank you.</p>
            </template>
            <template slot="footer">
                <button type="button" class="btn btn-primary btn-primary-insv" @click="dismissPopupCompleteProfile">Okay</button>
            </template>
        </popup-modal>
    </div>
</template>

<script>
import { convertDateToDDMMYYYY, convertDateToIso8601 } from '@/utilities';
import userProfileCommon from '@/components/user-profile';
import popupModal from '@/components/popup-modal';
export default {
    'name': 'PharmacyUserProfile',
    'components': {
        userProfileCommon,
        popupModal
    },
    'data': function () {
        return {
            'userProfile': {
                'name': null,
                'designation': null,
                'designationChoice': 'Mr.',
                'gender': 0,
                'birthDate': null,
                'email': null,
                'phoneNo': null,
                'identitifcationType': 0,
                'identificationNumber': null
            },
            'isSubmitMessageShown': false,
            'isSubmitMessageError': false,
            'submitMessage': ''
        };
    },
    mounted () {
        this.getProfile();
        this.$nextTick(() => {
            if (this.$store.state.user.isProfileCompleted === 0) {
                this.$refs.popupCompleteProfile.show();
            }
        });
    },
    'methods': {
        getProfile () {
            this.isSubmitMessageShown = false;
            this.$refs.userProfileForm.clearValidation();
            this.axios.get('Profile/GetUserProfile').then(({ data }) => {
                let profileData = data.data;
                this.userProfile.name = profileData.f;
                this.userProfile.email = profileData.e;
                this.userProfile.designationChoice = profileData.d;
                this.userProfile.identitifcationType = profileData.ict;
                this.userProfile.identificationNumber = profileData.ic;
                this.userProfile.birthDate = convertDateToDDMMYYYY(profileData.bd);
                this.userProfile.gender = profileData.g;
                this.userProfile.phoneNo = profileData.p;
            }).catch(() => {
            });
        },
        saveProfile () {
            this.isSubmitMessageShown = true;
            this.isSubmitMessageError = false;
            Promise.all([this.$refs.userProfileForm.validateForm()]).then(
                (validationResults) => {
                    this.$nextTick(() => {
                        if (validationResults.filter(v => v === false).length > 0) {
                        // focus to the first error
                            document.body.querySelector('.is-invalid').focus();

                            this.isSubmitMessageError = true;
                            this.submitMessage = 'You have error in the form. Please check your input(s) before saving your profile.';
                        } else {
                            this.submitMessage = 'Saving profile...';
                            if (this.userProfile.designationChoice !== -1) {
                                this.userProfile.designation = this.userProfile.designationChoice;
                            }
                            this.axios.post('Profile/UpdateUserProfile', {
                                'f': this.userProfile.name,
                                'd': this.userProfile.designation,
                                'e': this.userProfile.email,
                                'ict': this.userProfile.identitifcationType,
                                'ic': this.userProfile.identificationNumber,
                                'bd': convertDateToIso8601(this.userProfile.birthDate),
                                'g': this.userProfile.gender,
                                'p': this.userProfile.phoneNo
                            }).then(() => {
                                this.submitMessage = 'Successfully updated profile! Your information is saved and encrypted.';
                                this.$store.commit('completedProfile');
                            }).catch((error) => {
                                this.isSubmitMessageError = true;
                                if (error.response.data) {
                                    this.submitMessage = error.response.data.message;
                                } else {
                                    this.submitMessage = 'Error saving profile. Please try again.';
                                }
                            });
                        }
                    });
                });
        },
        dismissPopupCompleteProfile () {
            this.$refs.popupCompleteProfile.hide();
        }
    }
};

</script>

<style>

</style>
